export default {
  name: "new_project_modal",
  width: "90%",
  //   minWidth: 1080,
  height: "auto",
  scrollable: false,
  pivotY: 0.05,
  pivotX: 0.5,
  clickToClose: false,
  adaptive: true,
};
